const baseName = '/';

module.exports = {
  home: baseName
};
